<div class="bank-account">
  <astral-masked-input
    class="bank-account__field"
    [control]="form.controls['bankAccount']"
    [mask]="bankAccountMask"
    [helpText]="'TENANT.HELP_TEXT.BANK_ACCOUNT'"
  ></astral-masked-input>

  @if (hasBankAccount) {
    <div class="bank-account__field">
      <app-text-box-readonly [caption]="'TENANT.BANK'" [text]="bankName"></app-text-box-readonly>
    </div>
  }
</div>
